import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import aboutHero from "../image/landing/designer/Tattqr-img-2-couple-with-tattoo.webp";
import patternImage from "../image/landing/designer/bg-patterns.webp";
import "./AboutUs.css";

const highlights = [
  "Update content anytime without changing the tattoo design.",
  "Protect personal memories with optional lightweight PIN privacy.",
  "Share one QR tattoo that can hold audio, video, image, and text stories.",
];

const AboutUs = () => {
  const navigate = useNavigate();
  const [resolvedImageUrl, setResolvedImageUrl] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let settled = false;
    const nextImageUrl = aboutHero;

    setResolvedImageUrl("");
    setIsImageLoading(true);

    const preloaded = new Image();
    preloaded.decoding = "async";
    preloaded.fetchPriority = "high";

    const settle = () => {
      if (cancelled || settled) {
        return;
      }
      settled = true;
      setResolvedImageUrl(nextImageUrl);
      setIsImageLoading(false);
    };

    preloaded.onload = settle;
    preloaded.onerror = settle;
    preloaded.src = nextImageUrl;

    if (preloaded.decode) {
      preloaded.decode().then(settle).catch(() => {
        // Keep onload/onerror fallback for browsers that reject decode().
      });
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section
      className="about-us-section"
      style={{ "--about-pattern-image": `url(${patternImage})` }}
    >
      <div className="about-shell">
        <p className="about-kicker">About Us</p>
        <h1>Bridging the Gap Between Permanent Art and Digital Storytelling</h1>
        <p className="about-intro">
          TattQR turns tattoos into living memory portals. Every scan reveals
          the story behind your ink while giving you full control over what
          people experience.
        </p>

        <div className="about-grid">
          <div className="about-image-wrap">
            {(isImageLoading || !resolvedImageUrl) && (
              <div className="about-image-loader" aria-hidden="true">
                <span className="about-image-spinner" />
              </div>
            )}
            {resolvedImageUrl && (
              <img
                src={resolvedImageUrl}
                alt="Couple with QR tattoo story"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                onLoad={() => setIsImageLoading(false)}
                onError={() => setIsImageLoading(false)}
              />
            )}
          </div>

          <div className="about-copy-card">
            <p>
              At TattQR, tattoos are more than visual art. They hold meaning,
              emotion, and identity. Our platform connects your tattoo to
              digital experiences like videos, voice notes, photos, and text.
            </p>
            <p>
              Your tattoo stays permanent, but the content behind it can evolve
              with your story. That gives you a timeless design with a living
              digital layer.
            </p>

            <ul>
              {highlights.map((item) => (
                <li key={item}>
                  <FiCheckCircle />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="about-actions">
              <button type="button" onClick={() => navigate("/signup")}>
                Design My QR
              </button>
              <button
                type="button"
                className="about-outline-btn"
                onClick={() => navigate("/contact-us")}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
